import React, {useEffect, useState} from 'react';
import {View} from 'react-native';
import {PatternFormat} from 'react-number-format';
import {observer} from 'mobx-react-lite';

import BackButton from '../../components/rewards/BackButton';
import RewardsProgramImage from '../../components/rewards/ProgramImage';
import Button from '../../components/themed/Button';
import KeyboardAwareScrollView from '../../components/themed/KeyboardAwareScrollView';
import Text from '../../components/themed/Text';
import TextInput from '../../components/themed/TextInput';
import ContentView from '../../components/ui-controls/layout/ContentView';
import config from '../../config';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import {navigate} from '../../navigation/RootNavigation';
import {useStores} from '../../stores/use-stores';
import apiService from '../../transport/apiService';

const RewardsWelcomeBackScreen = observer(
  ({navigation}: RouteNavigatorScreenProps<AppRoute.REWARDS_WELCOME_BACK>) => {
    const {rewardsStore} = useStores();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSendCode = async () => {
      setIsSubmitting(true);
      try {
        const result = await apiService.rewardsVerifyExistingUserPhoneNumber({
          phoneNumber: rewardsStore.phoneNumber,
        });

        if (result?.status === 200) {
          navigate(AppRoute.REWARDS_VERIFICATION);
        } else {
          // TODO handle error
        }
      } catch (error) {
        // TODO handle error
      } finally {
        setIsSubmitting(false);
      }
    };

    return (
      <KeyboardAwareScrollView
        style={{flex: 1}}
        contentContainerStyle={{flex: 1}}
        keyboardShouldPersistTaps="always">
        <ContentView
          parentStyle={{flex: 1, paddingBottom: 16}}
          style={{flex: 1}}>
          <BackButton
            onPress={() => {
              navigation.navigate(AppRoute.REWARDS_SIGN_IN);
            }}
          />
          <RewardsProgramImage variant="onLight" />

          <View>
            <Text variant="heading1">LOOKS LIKE YOU HAVE AN ACCOUNT</Text>
          </View>
          <Text>
            It appears you already have an account with {config.APP_NAME}.
            {'\n\n'}
            So we can confirm we have the right details for you, we will need to
            verify your mobile number by sending you a verification code.
          </Text>

          <PatternFormat
            disabled
            containerStyle={{marginTop: 36}}
            format="(+61) ##########"
            allowEmptyFormatting
            customInput={TextInput}
            // Phone number without country code or area code
            value={rewardsStore.phoneNumber?.replace(/^\+61/, '') || ''}
            accessibilityLabel="Your mobile number:"
            autoCapitalize="none"
            autoComplete="tel"
            keyboardType="phone-pad"
            label="Your mobile number:"
            maxLength={20}
          />
          <View style={{gap: 8}}>
            <Button
              title={'SEND CODE'}
              onPress={handleSendCode}
              disabled={isSubmitting}
              loading={isSubmitting}
            />
          </View>
        </ContentView>
      </KeyboardAwareScrollView>
    );
  },
);

export default RewardsWelcomeBackScreen;
